
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { RaceDetailDto, TeamDto } from '@aoe/client';
import { Subscription } from 'rxjs';
import { LoadingSpinnerModule } from 'src/app/shared/design-system/loading-spinner/loading-spinner.module';
import { EditTeamFormModule } from '../../edit-team-form/edit-team-form.module';

@Component({
  selector: 'aoe-edit-team-dialog',
  templateUrl: './edit-team-dialog.component.html',
  styleUrl: './edit-team-dialog.component.scss',
  imports: [EditTeamFormModule, LoadingSpinnerModule, MatDialogModule]
})
export class EditTeamDialogComponent implements OnInit, OnDestroy {

  private readonly subs = new Subscription();
  races!: RaceDetailDto[];

  errors: { loadRaces: boolean } = { loadRaces: false }
  loadings: { loadRaces: boolean } = { loadRaces: false }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { team: TeamDto },
    // private readonly raceService: RaceService
  ) { }

  ngOnInit(): void {
    this.loadRaces();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private loadRaces() {
    this.loadings.loadRaces = true;
    this.errors.loadRaces = false;
    // this.subs.add(
    //   this.raceService.getRaces({ : true }).subscribe({
    //     next: (res) => {
    //       if (res.data)
    //         this.races = res.data.races as RaceDetailDto[]
    //       this.loadings.loadRaces = false;
    //     },
    //     error: () => {
    //       this.loadings.loadRaces = false;
    //       this.errors.loadRaces = true;
    //     }
    //   })
    // )
  }


}
